<template>
  <!-- Img Upload Modal -->
  <div
    class="modal fade"
    id="imgModal"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1"
    ref="modalElement"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <button
          type="button"
          class="close-model-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>
        <div class="content-model-me">
          <div class="modal-header">
            <h2 class="section-title">اضافة بانر اعلاني</h2>
          </div>

          <form ref="uploadForm" @submit.prevent="uploadAds()">
            <div class="modal-body">
              <div class="mb-3">
                <div class="label-row">
                  <label :for="detailsInputId" class="form-label">تفاصيل البانر</label>
                  <span class="optional">اختياري</span>
                </div>
                <textarea
                  class="form-control"
                  name="details"
                  v-model="details"
                  :id="detailsInputId"
                  rows="3"
                  placeholder="اكتب هنا"
                ></textarea>
                <div>بامكانك الكتابة على الصورة او عدم الكتابة</div>
              </div>

              <div class="upload-img my-3">
                <div class="upload-title">أضف صورة البانر أو فيديو</div>
                <input
                  type="file"
                  name="media"
                  accept="image/*,video/*"
                  :id="fileInputId"
                  class="hidden-input img-upload-input"
                  @change="uploadPanner"
                />
                <div class="dropzone">
                  <label :for="fileInputId" class="label-img lg mx-auto dz-btn">
                    <template v-if="!image && !videoSelected">
                      <img :src="require('../../assets/imgs/photo-camera.png')" alt="" class="dz-icon" />
                      <div class="dz-text">اضغط لإضافة صورة البانر أو فيديو</div>
                    </template>
                    <template v-else>
                      <div class="banner-preview-wrap">
                        <img v-if="image" :src="image" alt="Uploaded Image" class="uploaded-img" />
                        <div v-else class="video-pill">تم اختيار فيديو</div>
                        <button v-if="image || videoSelected" type="button" class="remove-img text-white" @click.stop.prevent="removeBannerImage">&times;</button>
                      </div>
                    </template>
                  </label>
                </div>
                <p class="image_notes">يرجي إضافة صورة بحجم 1220 * 480</p>
                <div class="img-upload-show"></div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="main-btn md up" :disabled="disabled">
                اضف البانر
                <div class="spinner-border" role="status" v-if="disabled">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
          </form>

          <ImageCropper
            v-if="showCropper"
            :src="cropSrc"
            :aspectRatio="null"
            :maxWidth="1920"
            :maxHeight="1200"
            @confirm="onCropConfirm"
            @cancel="onCropCancel"
          />
        </div>
      </div>
    </div>
  </div>

  <v-dialog v-model="dialog" width="auto" persistent>
    <v-card>
      <div class="d-flex justify-content-end w-100">
        <button
          type="button"
          class="close-model-btn"
          style="font-size: 22px"
          @click="dialog = false"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>
      </div>

      <div class="modal-header">
        <h2 class="section-title">{{ $t("common.sendSuc") }}</h2>
      </div>

      <div class="modal-body">
        <img :src="done" alt="Success" class="done-img" />
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import ImageCropper from '../Shared/ImageCropper.vue';
import { Modal } from 'bootstrap';

export default {
  data() {
    return {
      image: null,
      done: require("../../assets/imgs/done.gif"),
      widthAll: false,
      details: "",
      detailsInputId: 'bannerDetailsInput-' + Math.random().toString(36).slice(2),
      fileInputId: 'imgUpload-' + Math.random().toString(36).slice(2),
      // adPanner: false, // No longer used for visibility
      dialog: false,
      disabled: false,
      videoSelected: false,
      showCropper: false,
      cropSrc: '',
      originalFileDataUrl: '',
      videoDataUrl: '',
      bsModal: null,
      onShownHandler: null,
      onHiddenHandler: null,
    };
  },
  components: { ImageCropper },
  mounted() {
    if (this.$refs.modalElement) {
        this.bsModal = new Modal(this.$refs.modalElement);
        this.onShownHandler = () => {
          this.hydrateFromStorage();
        };
        this.onHiddenHandler = () => {
          this.image = null;
          this.videoSelected = false;
          this.widthAll = false;
          this.cropSrc = '';
          this.originalFileDataUrl = '';
          this.videoDataUrl = '';
          this.showCropper = false;
          if (this.$refs.uploadForm) {
            const fileInput = this.$refs.uploadForm.querySelector('input[type="file"]');
            if (fileInput) fileInput.value = '';
          }
          document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
          document.body.classList.remove("modal-open");
          document.body.style.paddingRight = "";
        };
        this.$refs.modalElement.addEventListener('shown.bs.modal', this.onShownHandler);
        this.$refs.modalElement.addEventListener('hidden.bs.modal', this.onHiddenHandler);
    }
  },
  beforeUnmount() {
    if (this.$refs.modalElement) {
      if (this.onShownHandler) this.$refs.modalElement.removeEventListener('shown.bs.modal', this.onShownHandler);
      if (this.onHiddenHandler) this.$refs.modalElement.removeEventListener('hidden.bs.modal', this.onHiddenHandler);
    }
    if (this.bsModal) {
      this.bsModal.hide();
    }
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.paddingRight = "";
  },
  methods: {
    hydrateFromStorage() {
      const txt = window.localStorage.getItem('banner_text') || '';
      this.details = txt;
      this.videoSelected = false;
      this.image = null;
      this.widthAll = false;
      this.cropSrc = '';
      this.originalFileDataUrl = '';
      window.localStorage.removeItem('banner_img');
      window.localStorage.removeItem('banner_video');
    },
    openPannerModal(){
      this.hydrateFromStorage();
      if (this.bsModal) {
          this.bsModal.show();
      }
    },
    uploadPanner(e) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const isVideo = (file.type || '').startsWith('video/');
          if (isVideo) {
            this.videoSelected = true;
            this.image = null;
            this.cropSrc = '';
            this.originalFileDataUrl = '';
            this.videoDataUrl = event.target.result || '';
            this.widthAll = true;
          } else {
            this.videoSelected = false;
            this.cropSrc = event.target.result;
            this.originalFileDataUrl = event.target.result;
            this.showCropper = true;
          }
        };
        reader.readAsDataURL(file);
      } else {
        this.image = require("../../assets/imgs/photo-camera.png");
        this.widthAll = false;
        this.videoSelected = false;
        this.cropSrc = '';
        this.originalFileDataUrl = '';
        window.localStorage.removeItem('banner_video');
        window.localStorage.removeItem('banner_img');
      }
    },
    onCropConfirm({ dataUrl }) {
      this.image = dataUrl;
      this.widthAll = true;
      this.showCropper = false;
      this.cropSrc = '';
    },
    onCropCancel() {
      this.showCropper = false;
      this.cropSrc = '';
      if (!this.image) {
        this.widthAll = false;
        window.localStorage.removeItem('banner_img');
      }
    },
    removeBannerImage() {
      this.image = null;
      this.videoSelected = false;
      this.widthAll = false;
      this.cropSrc = '';
      this.originalFileDataUrl = '';
      this.videoDataUrl = '';
      window.localStorage.removeItem('banner_img');
      window.localStorage.removeItem('banner_video');
      if (this.$refs.uploadForm) {
        const fileInput = this.$refs.uploadForm.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = '';
      }
    },
    async uploadAds() {
      this.disabled = true;
      try {
        window.localStorage.setItem('bannerOrAd', 'banner');
        window.localStorage.setItem('banner_text', this.details);
        window.localStorage.removeItem('banner_id');
        
        if (this.image == null && this.originalFileDataUrl) {
            this.image = this.originalFileDataUrl;
        }

        if (this.image == null && !this.videoSelected) {
          this.$swal({
            icon: "error",
            title: 'يجب إضافة صورة البانر',
            timer: 2000,
            showConfirmButton: false,
          });
          this.disabled = false;
          return;
        }

        if (this.image) {
          window.localStorage.setItem('banner_img', this.image);
        } else if (this.videoSelected && this.videoDataUrl) {
          window.localStorage.setItem('banner_video', this.videoDataUrl);
        } else if (this.videoSelected) {
          this.$swal({
            icon: "error",
            title: 'يجب إضافة صورة أو فيديو البانر',
            timer: 2000,
            showConfirmButton: false,
          });
          this.disabled = false;
          return;
        }

        if (this.bsModal) {
          this.bsModal.hide();
        }
        document.querySelectorAll(".modal-backdrop").forEach((element) => {
          element.remove();
        });
        document.body.classList.remove("modal-open");
        document.body.style.paddingRight = "";

        await this.$router.push('/bannerPayment');

      } catch (error) {
        console.error("Error uploading ads:", error);
        this.$swal({
            icon: "error",
            title: 'حدث خطأ',
            text: error.message,
            timer: 3000,
            showConfirmButton: false,
        });
        this.disabled = false;
      }
    },
  },
};
</script>

<style>
.modal-content { max-height: 92vh; }
.content-model-me { position: relative; height: 100%; display: flex; flex-direction: column; padding-top: 8px; }
.content-model-me .modal-header { padding-top: 4px; padding-bottom: 8px; }
.content-model-me .modal-body { padding-top: 8px; padding-bottom: 8px; overflow-y: auto; }
.label-row { display: flex; align-items: center; justify-content: space-between; }
.label-row .optional { color: gray; font-size: 14px; }
.upload-title { text-align: center; font-weight: 600; margin-bottom: 8px; }
.dropzone { border: 2px dashed #2abdc7; border-radius: 10px; padding: 10px; display: flex; align-items: center; justify-content: center; min-height: 160px; background: #f9f9fb; position: relative; }
.dz-btn { display: flex; flex-direction: column; align-items: center; gap: 8px; width: 100%; }
.dz-icon { width: 48px; height: 48px; object-fit: contain; opacity: 0.8; }
.dz-text { color: #6b6b6b; font-size: 14px; text-align: center; }
.video-pill { background: #2abdc7; color: #fff; padding: 8px 12px; border-radius: 999px; font-size: 14px; }
.upload-img .label-img.lg .uploaded-img{
  max-width: 100%;
  width: 100%;
  height: auto;
  object-fit: contain;
}
.dropzone .label-img {
  overflow: visible;
}
.banner-preview-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px;
}
.banner-preview-wrap .remove-img {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 30px;
  height: 30px;
  font-size: 18px;
  z-index: 10;
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.25);
  cursor: pointer;
}
.image_notes{
  font-size: 14px;
  text-align: center;
  margin-top: 6px;
}
.modal-footer { margin-top: 8px; }

@media (orientation: portrait) {
  .dropzone { min-height: 140px; }
}
@media (max-width: 576px) {
  .dropzone { padding: 8px; min-height: 130px; }
  .content-model-me { padding-top: 4px; }
  .content-model-me .modal-header { padding-top: 2px; padding-bottom: 6px; }
  .content-model-me .modal-body { padding-top: 4px; padding-bottom: 6px; }
}
@media (orientation: landscape) and (max-width: 992px) {
  .dropzone { min-height: 150px; }
}
</style>
